import { useQuery } from '@tanstack/react-query';
import { getEmailRender } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export const CONTENT_TYPE = {
    HTML: 'text/html',
    PLAIN: 'text/plain',
};
export default function useInvoicesEmailRender(emailId) {
    const { data, isLoading } = useQuery({
        queryKey: ['invoices', 'render', emailId],
        queryFn: () => getEmailRender(emailId),
        onError: (error) => trackError(error),
    });

    return {
        isLoading,
        body: data?.email_body ?? '',
        contentType: data?.email_body_type ?? CONTENT_TYPE.HTML,
    };
}
